<template>
  <div class="sports-wrapper-skeleton">
    <div class="sport-header-skeleton">
      <StSkeletonLoader
        height="24px"
        width="24px"
        bg-color="#2d2d39"
        type="circle"
        :shimmer-opacity="0.28"
      />
      <StSkeletonLoader
        height="8px"
        width="84px"
        bg-color="#2d2d39"
        :shimmer-opacity="0.28"
      />
    </div>
    <div class="sport-container-group-skeleton">
      <EventItemCompactSkeleton v-for="i in 3" :key="i" />
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
.sports-wrapper-skeleton {
  background: var(--background-base);
  border-radius: var(--border-radius-200) var(--border-radius-200) 0 0;
}

.sport-header-skeleton {
  display: flex;
  gap: var(--spacing-075);
  align-items: center;
  padding: var(--spacing-100) var(--spacing-200);
}

.sport-container-group-skeleton {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-075);
  padding: 0 var(--spacing-200);
}
</style>
